import store from '@/store'

const { quoteDistributionDraft } = store.state.staticModule
export default function permission() {
  const getPermissions = quoteDistribution => {
    const perm = {
      can_send: false,
      can_update: false,
      can_delete: false,
      can_regenerate: false,
      can_create_quote: false,
    }
    const quoteDistributionPermissions = quoteDistribution.total_quote_permissions ? quoteDistribution.quoteDistribution_permissions : {}
    return {
      ...perm,
      ...quoteDistributionPermissions,
    }
  }
  const canUpdate = quoteDistribution => quoteDistribution.status === quoteDistributionDraft // getPermissions(quoteDistribution).can_update

  const canDelete = quoteDistribution => quoteDistribution.status === quoteDistributionDraft // getPermissions(quoteDistribution).can_delete

  const canSend = quoteDistribution => quoteDistribution.status === quoteDistributionDraft // getPermissions(quoteDistribution).can_send

  return {
    canUpdate,
    canDelete,
    canSend,
  }
}
